<template>
  <div class='container container-padded-small order'>
    <form @submit.prevent='validate_order' :class='{ errors: $v.$error }' novalidate>
      <div class='order-left'>
        <div class="order-top">
          <h1>{{preorder ? 'Pre-Order' : 'Order'}}</h1>

          <div v-show="false" class="remaining">
            <p v-if="hide_standard" class="order-remaining-count">
              Only {{ numberWithCommas(remaining.pro.remaining) }} left of {{ numberWithCommas(remaining.pro.divisor) }}
            </p>

            <p v-else-if="hide_pro" class="order-remaining-count">
              Only {{ numberWithCommas(remaining.pro.remaining) }} left of {{ numberWithCommas(remaining.pro.divisor) }}
            </p>

            <p v-else class="order-remaining-count">
              Only {{ numberWithCommas(remaining.standard.remaining + remaining.pro.remaining) }} left of {{ numberWithCommas(remaining.standard.divisor + remaining.pro.divisor) }}
            </p>
          </div>
        </div>

        <p v-if='preorder' class="preorder-estimated-delivery">
          Estimated Ship Date: <strong>{{estimated_delivery}}</strong>
        </p>

        <div class="line" />

        <div style="background-color: rgba(250,250,250,0.8);padding: 2em;" v-if="variant=='4.7' || variant=='4.8' || variant=='4.17'">
          <p class="" style="font-weight: 800;margin:0px;">Place your order now to get an Arsenal 2 from our {{estimated_delivery}} production run. Due to high demand Arsenal is currently backordered until then. Limited spots remain.</p>
        </div>
        <div style="background-color: rgba(250,250,250,0.8);padding: 2em;" v-if="variant=='4.10'||variant=='4.15'">
          <p class="" style="font-weight: 800;margin:0px;">Our next batch of Arsenal's arrives in {{estimated_delivery}}! &nbsp;Order today to get a unit from that manufacturing run.</p>
        </div>
        <div style="background-color: rgba(250,250,250,0.8);padding: 2em;" v-if="variant=='4.11'">
          <p class="" style="font-weight: 800;margin:0px;">Our next batch of Arsenal's arrives in {{estimated_delivery}}! Due to parts shortages and high demand, we're currently backordered. <u>Order today to get a unit from our {{estimated_delivery}} production run.</u></p>
        </div>
        <div v-if='preorder' style="background-color: rgba(250,250,250,0.8);padding: 2em;">
          <p class="" style="font-weight: 800;margin:0px;">Hey everyone, we're having trouble keeping up with demand (really sorry!). Our next units will start arriving in {{estimated_delivery}}. Units will be sent out based on order date.
          <br />
          <br />
          Ryan &nbsp;<span style="color: slategray; font-size: 14px"> - Creator of Arsenal</span>
        </p>
        </div>

        <Products
          :order="order"
          :prices="prices"
          :$v="$v"
          :hide_pro="hide_pro"
          :hide_standard="hide_standard"
          :continental_usa="continental_usa"
          :hide_phone_mount="hide_phone_mount"
          :hide_power_bank="hide_power_bank"
          :hide_micro_sd_card="hide_micro_sd_card"
          :variant="variant"
        />
        <StripePaymentRequestButton
          :order='order'
          :estimated_delivery='estimated_delivery'
          :express_checkout='express_checkout'
          :express_checkout_data='express_checkout_data'
          :prices='prices'
          :preorder='preorder'
          :hide_pro='hide_pro'
          :hide_standard='hide_standard'
          :did_initiate_express_checkout='did_initiate_express_checkout'
          :did_cancel_express_checkout='did_cancel_express_checkout'
          :did_complete_express_checkout='did_complete_express_checkout'
          :shipping_address_did_change='express_checkout_shipping_address_did_change'
        />

        <section class="contact-info">
          <h3 class="text-center">Let's get some contact info.</h3>

          <div class='row'>
            <div class='col s12 l7'>
              <input type='email' name='email' v-model.trim='order.email' @input='event => debounced_save_cart()' placeholder='Email'>
              <div class='error' v-if='!$v.order.email.required'>Email is required</div>
              <div class='error' v-if='!$v.order.email.email'>Email is not the right format</div>
            </div>

            <div class='col s12 l5'>
              <input type='tel' name='phone' v-model.trim='order.phone_number' placeholder='Phone Number'>
              <div class='error' v-if='!$v.order.phone_number.required'>Phone Number is required</div>
              <div class='error' v-if='!$v.order.phone_number.minLength'>Phone Number must be more than 6 numbers.</div>
              <div class='error' v-if='!$v.order.phone_number.maxLength'>Phone Number must be less than 255 numbers.</div>
            </div>
          </div>
        </section>

        <section class='shipping-address'>
          <h3>SHIPPING ADDRESS</h3>
          <OrderAddress @update='address_updated' :address='order.shipping_address' :$v='$v.order.shipping_address' />
          <div class='errors' style="position:relative; top:-1rem">
            <div v-if='order.errors.shipping_address' class='error'>{{ order.errors.shipping_address }}</div>
            <div v-if='order.errors.calculate_tax' class='error'>{{ order.errors.calculate_tax }}</div>
            <div v-if='order.errors.promo_code' class='error'>{{ order.errors.promo_code }}</div>
          </div>
        </section>

        <ShippingMethod :preorder='preorder' :order='order' :$v='$v.order' :amazon_fulfillment_enabled='amazon_fulfillment_enabled' />

        <section class='payment-method'>
          <h3>
            PAYMENT METHOD
          </h3>
          <StripeCard ref='stripe' :express_checkout='express_checkout' />
        </section>

        <section class="checkboxes">
          <label v-if='false' class='checkbox-label'>
            I have read and agreed to the terms outlined in the <span v-if="preorder">pre-</span>order <a href='/terms-and-conditions' target='_blank'>Terms and Conditions</a>.
            <input type='checkbox' name='terms' v-model='order.terms'>
            <span class="checkmark"></span>
            <div class='error' v-if='!$v.order.terms.required'>Please review and accept the terms before ordering</div>
          </label>

          <br />

          <label v-if='false' class='checkbox-label'>
            I agree to receive email notifications regarding product and feature updates, news, and promotions.  View <a href='/privacy-policy' target='_blank'>Privacy Policy</a>.
            <input type='checkbox' name='subscribe' v-model='order.subscribe'>
            <span class="checkmark"></span>
          </label>

          <div v-if='show_customs_checkbox'>
            <label class='checkbox-label'>
              I understand that upon Arsenal's arrival in my country I am responsible for any customs/duties, VAT, other local taxes, and/or customs/duties handling fees charged by couriers via local customs.
              <input type='checkbox' name='agree_to_customs' v-model='order.agree_to_customs'>
              <span class="checkmark"></span>
              <div class='error' v-if='!$v.order.agree_to_customs.required'>You must agree to customs fees</div>
            </label>
          </div>

          <div v-if='preorder && false'>
            <br />
            <label class='checkbox-label'>
              I understand Arsenal 2’s Estimated Delivery Date is {{estimated_delivery}} and that any other items ordered will ship with Arsenal 2.
              <input type='checkbox' name='agree_to_preorder' v-model='order.agree_to_preorder'>
              <span class="checkmark"></span>
              <div class='error' v-if='!$v.order.agree_to_preorder.required'>You must agree to these terms</div>
            </label>
          </div>
        </section>

        <spinner-button :spin='submitting' class='btn btn-full btn-large place-order'>Place <span v-if="preorder">Pre-</span>Order</spinner-button>


        <p style="padding-top: 2em" class="text-center order-cables">
          Looking for replacement USB cables? You can order them <a href="/order-cables" target="_blank">here</a>.
        </p>
      </div>

      <div class='order-right'>
        <Totals :order='order' :subtotal='subtotal' :shipping='shipping' :tax='tax' :total='raw_total' :promo_code_discount='promo_code_discount' :prices='prices' :hide_pro='hide_pro'  :hide_standard='hide_standard' />

        <spinner-button :spin='submitting' class='btn btn-full btn-large place-order'>Place <span v-if="preorder">Pre-</span>Order</spinner-button>

        <p style="padding-top: 2em" class="text-center order-cables">
          Looking for replacement USB cables? You can order them <a href="/order-cables" target="_blank">here</a>.
        </p>

        <div class="box" style="margin-top: 3rem">
          <img src="~app/assets/images/DPReview-logo.png">
          <h3>"Arsenal is artificial intelligence for your mirrorless or DSLR camera"</h3>
          <h4>- Digital Photography Review</h4>
        </div>

        <div class="box">
          <h3>We're confident you'll love Arsenal!</h3>
          <p>You can return Arsenal within 90 days for a full refund (minus shipping). Check out our <a href="/returns" target="_blank">return policy</a> and <a href="/warranty" target="_blank">warranty page</a> for details.</p>
        </div>
      </div>
    </form>

    <div class='bottom-padding' />

    <OrderAddressModal :show='address_modal' :order='order' :cancel='close_address_modal' :submit_via_modal='submit_via_modal' />
  </div>
</template>

<script>
  import * as Sentry from '@sentry/browser'
import countries from 'app/countries.json'
import { is_military_address, is_taxable_country, is_us_territory } from 'app/helpers/AddressHelpers'
import country_name_from_alpha2 from 'app/helpers/CountryHelpers'
import { noNumbers, noSpecialCharacters } from 'app/helpers/Validators'
import 'core-js/web/url-search-params'
import debounce from 'lodash/debounce'
import find from 'lodash/find'
import includes from 'lodash/includes'
import times from 'lodash/times'
import { email, maxLength, minLength, required } from 'vuelidate/lib/validators'

  import OrderAddress from 'app/components/orders/OrderAddress'
import OrderAddressModal from 'app/components/orders/OrderAddressModal'
import Products from 'app/components/orders/Products'
import ShippingMethod from 'app/components/orders/ShippingMethod'
import StripeCard from 'app/components/orders/StripeCard'
import StripePaymentElement from 'app/components/orders/StripePaymentElement'
import StripePaymentRequestButton from 'app/components/orders/StripePaymentRequestButton'
import Totals from 'app/components/orders/Totals'
import SpinnerButton from 'app/components/shared/SpinnerButton'
import OrderTrackingMixin from 'app/mixins/OrderTrackingMixin'
import TotalsMixin from 'app/mixins/TotalsMixin'

  export default {
    mixins: [TotalsMixin, OrderTrackingMixin],
    props: [
      'prices',
      'estimated_delivery',
      'preorder',
      'variant',
      'amazon_fulfillment_enabled',
      'hide_pro',
      'hide_standard',
      'prepopulated_order',
      'show_klarna_branding',
      'conversion_tracker_percent',
      'continental_usa',
      'remaining',
      'hide_phone_mount',
      'hide_power_bank',
      'hide_micro_sd_card'
    ],
    created() {
      this.debounced_save_cart = debounce(this.save_cart, 500)
    },
    beforeMount () {
      if (this.prepopulated_order) {
        Object.assign(this.order, this.prepopulated_order)
      }
    },
    async mounted () {
      const params = new URLSearchParams(window.location.search)
      const promo_code = params.get('promo_code')
      if (promo_code) this.validate_promo_code(promo_code)

      const arsenal_quantity = parseInt(params.get('arsenal_quantity'))
      if (arsenal_quantity && arsenal_quantity > 0) {
        this.order.products.arsenal.prepopulated = true;
        this.order.products.arsenal.quantity = arsenal_quantity
        times(arsenal_quantity, () => this.order.products.arsenal.cables.push(''))
      }

      const arsenal_pro_quantity = parseInt(params.get('arsenal_pro_quantity'))
      if (arsenal_pro_quantity && arsenal_pro_quantity > 0) {
        this.order.products.arsenal_pro.prepopulated = true;
        this.order.products.arsenal_pro.quantity = arsenal_pro_quantity
        times(arsenal_pro_quantity, () => this.order.products.arsenal_pro.cables.push(''))
      }


      this.track_initiate_checkout()

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({'event': 'optimize.activate'})
      }
    },
    data () {
      return {
        arsenal_added: false,
        submitting: false,
        skip_address_validation: false,
        address_modal: false,
        express_checkout: false,
        express_checkout_data: {
          email: '',
          phone_number: '',
          shipping_name:           '',
          shipping_address_1:      '',
          shipping_address_2:      '',
          shipping_city:           '',
          shipping_country:        '',
          shipping_state:          '',
          shipping_zipcode:        '',
        },
        order: {
          products: {
            arsenal: { quantity: 0, cables: [] },
            arsenal_pro: { quantity: 0, cables: [] },
            phone_mount:   { quantity: 0 },
            battery:       { quantity: 0 },
            micro_sd_card: { quantity: 0 },
          },
          email: '',
          phone_number: '',
          shipping_address: {
            name: '',
            address_1: '',
            address_2: '',
            city: '',
            country: 'United States of America',
            state: '',
            zipcode: ''
          },
          shipping_method: null,
          tax_rate: null,
          shipping_taxable: null,
          promo_code: {},
          terms: false,
          subscribe: false,
          agree_to_customs: false,
          agree_to_preorder: false,
          errors: {}
        },
        payment_method: null
      }
    },
    validations: {
      order: {
        email: {
          required () {
            if (this.express_checkout) return true
            return !!this.order.email
          },
          email
        },
        phone_number: {
          required () {
            if (this.express_checkout) return true
            return !!this.order.phone_number
          },
          minLength: minLength(6),
          maxLength: maxLength(255)
        },
        products: {
          arsenal: {
            cables: {
              $each: { required }
            }
          },
          arsenal_pro: {
            cables: {
              $each: { required }
            }
          },
        },
        shipping_address: {
          name: {
            required () {
              if (this.express_checkout) return true
              return !!this.order.shipping_address.name
            },
            maxLength: maxLength(100),
            noSpecialCharacters,
            noNumbers,
            hasFirstAndLastName() {
              if (!this.order.shipping_address.name) {
                return true   // handled by `required`
              }
              // Look for ANY unicode whitespace between characters so names that use
              // non-ASCII space characters (e.g. ideographic spaces) validate correctly.
              return /\s/.test(this.order.shipping_address.name.trim())

            }
          },
          address_1: {
            required () {
              if (this.express_checkout) return true
              return !!this.order.shipping_address.address_1
            },
            maxLength: maxLength(45),
            noSpecialCharacters
          },
          address_2: {
            maxLength: maxLength(45),
            noSpecialCharacters
          },
          city: {
            required () {
              if (this.express_checkout) return true
              return !!this.order.shipping_address.city
            },
            maxLength: maxLength(255),
            noSpecialCharacters
          },
          state: {
            presence () {
              if (this.express_checkout) return true
              const country = find(countries, (country) => { return country.name == this.order.shipping_address.country })
              if (country.states.length === 0) return true
              return !!this.order.shipping_address.state
            }
          },
          zipcode: {
            presence () {
              if (this.express_checkout) return true
              const country = find(countries, (country) => { return country.name == this.order.shipping_address.country })
              if (country.postal_code === false) return true
              return !!this.order.shipping_address.zipcode
            },
            minLength ()  {
              if (this.express_checkout) return true
              const country = find(countries, (country) => { return country.name == this.order.shipping_address.country })
              if (country.postal_code === false) return true
              return String(this.order.shipping_address.zipcode || '').length >= 3
            },
            maxLength: maxLength(255),
            format () {
              if (this.express_checkout) return true
              // Only validate US States
              if (this.order.shipping_address.country != 'United States of America') return true
              if (is_us_territory(this.order.shipping_address.state)) return true
              if (is_military_address(this.order.shipping_address.state)) return true

              if (!this.order.shipping_address.zipcode) return false
              let numbers = this.order.shipping_address.zipcode.match(/\d/g).join('')
              return numbers.length == 5 || numbers.length == 9
            }
          }
        },
        shipping_method: {
          required () {
            if (this.express_checkout) return true
            if (this.preorder) return true
            return !!this.order.shipping_method
          }
        },
        terms: {
          required () {
            // currently disabled in lieu of a declaritive statement
            return true

            if (this.express_checkout) return true
            return false
          }
        },
        agree_to_customs: {
          required () {
            if (!this.show_customs_checkbox) return true
            return this.order.agree_to_customs
          }
        },
        agree_to_preorder: {
          required() {
            // currently disabled
            return true
            // if (!this.preorder) return true
            // return this.order.agree_to_preorder
          }
        }
      }
    },
    computed: {
      show_customs_checkbox () {
        // show the customs checkbox for any country we can't calculate/charge tax for
        return !is_taxable_country(this.order.shipping_address.country)
      },
    },
    methods: {
      close_address_modal () {
        this.reset_form()
        this.address_modal = false
      },
      submit_via_modal () {
        this.address_modal = false
        this.skip_address_validation = true
        this.submitting = false
        this.validate_order()
      },
      address_updated () {
        if (this.preorder) this.update_shipping_method()
        this.update_tax()
      },
      update_shipping_method () {
        const fulfillerName = this.order.default_fulfillers[this.order.shipping_address.country]

        this.order.shipping_method = this.order.shipping_methods.find((shipping_method) => {
          return shipping_method.fulfiller === fulfillerName &&
            shipping_method.name === 'Standard Shipping' &&
            shipping_method.country === this.order.shipping_address.country
        })
      },
      async update_tax (force_update = false) {
        let body = {
          taxable:  true,
          subtotal: this.subtotal,
          shipping: this.shipping
        }

        if (this.express_checkout) {
          if (this.express_checkout_data.shipping_country == '' && this.express_checkout_data.shipping_city == '' && this.express_checkout_data.shipping_zipcode == '') {
            this.$set(this.order, 'tax_rate', 0)
            this.$set(this.order, 'shipping_taxable', false)
            return
          }

          Object.assign(body, {
            city:     this.express_checkout_data.shipping_city,
            state:    this.express_checkout_data.shipping_state,
            zip:      this.express_checkout_data.shipping_zipcode,
            country:  this.express_checkout_data.shipping_country
          })
        } else {
          if (this.$v.order.shipping_address.$invalid) {
            this.$set(this.order, 'tax_rate', 0)
            this.$set(this.order, 'shipping_taxable', false)
            return
          }

          Object.assign(body, {
            street:   this.order.shipping_address.address_1,
            city:     this.order.shipping_address.city,
            state:    this.order.shipping_address.state,
            zip:      this.order.shipping_address.zipcode,
            country:  this.order.shipping_address.country,
          })
        }

        if (JSON.stringify(body) != this.last_update_tax_request || force_update || !this.order.tax_rate) {
          this.last_update_tax_request = JSON.stringify(body)
          this.$set(this.order.errors, 'calculate_tax', null)

          try {
            const response = await this.$http.post('/orders/calculate_tax', body);
            this.$set(this.order, 'tax_rate', response.body.tax_rate);
            this.$set(this.order, 'shipping_taxable', response.body.shipping_taxable);
          } catch (error) {
            this.$set(this.order.errors, 'calculate_tax', error.body.error);
          }
        }

        return this.order
      },
      validate_promo_code (promo_code) {
        this.$http.post('/orders/validate_promo_code', { promo_code }).then(response => {
          this.$set(this.order, 'promo_code', response.body)
        }, response => {
          this.$set(this.order.errors, 'promo_code', `An error occurred while trying to validate the promo code: ${response.body.error}`)
        })
      },
      validate_order () {
        if (this.submitting) return
        this.submitting = true

        if (this.isDefined('gtag')) {
          gtag('event', 'order submitted', { event_category: 'interactions' })
        }

        this.$v.$touch()

        if (this.subtotal == 0) {
          const message = 'Please select a product to purchase.'
          this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
          this.reset_form()
          this.scroll_to_products()
          return
        }

        if (this.order.tax_rate == null) {
          this.update_tax(true)
        }

        if (this.$refs.stripe.uses_payment_intents()) {
          // StripePaymentElement.vue
          // 1. create order and update payment intent
          // 2. if that's successful confirm payment clientside
          // 3. In the event a server side validation failed,
          //    save the order id locally and update the order
          this.submit_order_with_payment_pending(this.$refs.stripe.payment_intent_id(), this.$refs.stripe.client_secret()).then((response) => {
            if (this.order.subscribe) this.subscribe(this.order.email)

            // the order has been successfully created and
            // is ready to confirmPayment
            this.confirm_payment_intent(response.uid)
          },(error, response) => {
            this.handle_order_error(error, response)
          })
        } else {
          // tokenized payment details (StripeCard.vue)
          this.$refs.stripe.create_token(result => {
            if (result.error) {
              const message = 'Some fields have errors. Please correct them and try again.'
              this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
              this.reset_form()
              if (includes(this.order.products.arsenal.cables, '') || includes(this.order.products.arsenal_pro.cables, '')) {
                this.scroll_to_products()
              }
            } else {
              this.stripe_source_id = result.token.id
              this.card = result.token.card
              this.submit_order(result)
            }
          })
        }
      },
      serialize_order() {
        let body = {
          products:                this.order.products,
          email:                   this.order.email,
          phone_number:            this.order.phone_number,
          shipping_name:           this.order.shipping_address.name,
          shipping_address_1:      this.order.shipping_address.address_1,
          shipping_address_2:      this.order.shipping_address.address_2,
          shipping_city:           this.order.shipping_address.city,
          shipping_country:        this.order.shipping_address.country,
          shipping_state:          this.order.shipping_address.state,
          shipping_zipcode:        this.order.shipping_address.zipcode,
          promo_code:              this.order.promo_code.code,
          stripe_source_id:        this.stripe_source_id,
          payment_method:          this.payment_method,
          utm_json:                localStorage.getItem('utm_data') || '{}',
          fb_json:                 localStorage.getItem('fbclid') || '{}',
          intercom_visitor_id:     Intercom('getVisitorId'),
          skip_address_validation: this.skip_address_validation,
          total:                   this.raw_total,
        }

        if (this.card) {
          body.card_exp_month = this.card.exp_month
          body.card_exp_year = this.card.exp_year
          body.card_last_4 = this.card.last4
          body.card_brand = this.card.brand
        }

        if (this.express_checkout) {
          // assign name, email, phone and shipping address
          // that we got back from express checkout
          Object.assign(body, this.express_checkout_data)
        }

        // for non-preorders, add the shipping method
        if (!!this.order.shipping_method) {
          body.shipping_method_id = this.order.shipping_method.id
          body.estimated_delivery = this.order.shipping_method.estimated_delivery
        }

        return body
      },

      submit_order_with_payment_pending(payment_intent_id, client_secret) {
        return new Promise((resolve, reject) => {
          let body = this.serialize_order()

          // assign the payment intent
          body.stripe_payment_intent_id = payment_intent_id

          if (!this.validate_without_submitting()) {
            reject("Some fields have errors. Please correct them and try again.", null)
          } else {
            let path = '/orders'

            if (this.order.uid) {
              body.payment_intent_client_secret = client_secret
              path = `/orders/${this.order.uid}/update_unpaid`
            }
            this.$http.post(path, body).then(response => {
              resolve(response.body)
            }, response => {
              reject(response.status, response)
            })
          }
        })
      },
      validate_without_submitting() {
        if (this.$v.$error) {
          let message = 'Some fields have errors. Please correct them and try again.'
          this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
          this.reset_form()
          if (includes(this.order.products.arsenal.cables, '') || includes(this.order.products.arsenal_pro.cables, '')) {
            this.scroll_to_products()
          }
          return false
        } else {
          return true
        }
      },
      // for payment intent orders
      handle_order_error(error, response) {
        console.log(`handle_order_error: ${error}`)

        if (response) {
          // Save the order uid, so we update the order next
          // time instead of create
          this.order.uid = response.body.order_uid
        }

        if (error == 422) {
          // address didn't validate
          this.address_modal = true
        } else {
          this.reset_form()
          let error_message = 'Something went wrong.  Please try again or contact support.'

          if (response?.body?.error) {
            error_message = response?.body?.error
          } else if (typeof(error) == "string") {
            error_message = error
          }

          this.$toast(error_message, { horizontalPosition: 'center', verticalPosition: 'top' })

          Sentry.addBreadcrumb({
            message: '[CAUGHT] error with analytics (Order)'
          });
          Sentry.captureException(new Error('broken: ' + response?.status + ' : '+ error));
        }
      },
      async confirm_payment_intent(order_uid) {
        // if this step fails, we want to treat
        // another submit order as an update
        this.order.uid = order_uid

        const {error} = await this.$refs.stripe.confirm_payment(order_uid, this.order.shipping_address.name, this.order.email)

        // handle payment failed
        if (error) {
          this.reset_form()
          console.log(`payment failed: ${error.message}`)
          this.$toast(error.message, { horizontalPosition: 'center', verticalPosition: 'top' })
        }
      },
      submit_order (result) {
        const body = this.serialize_order()

        if (!this.validate_without_submitting()) {
          return
        }

        return new Promise((resolve, reject) => {
          this.$http.post('/orders', body).then(response => {
            resolve(response.body)

            if (this.order.subscribe) this.subscribe(this.order.email)
            this.track_successful_order(response.body, this.prices)

            // sleep for 1/2 second to make sure GA logs
            setTimeout(function() {
              window.location = '/success'
            }, 500)
          }, response => {
            reject(response.status)

            if (response.status === 422) {
              this.address_modal = true
            } else {
              this.reset_form()
              let error = response.body.error || 'Something went wrong.  Please try again or contact support.'

              this.$toast(error, { horizontalPosition: 'center', verticalPosition: 'top' })

              Sentry.addBreadcrumb({
                message: '[CAUGHT] error with analytics (Order)'
              });
              Sentry.captureException(new Error('broken: ' + response.status + ' : '+ error));
            }
          })
        })
      },
      track_initiate_checkout () {
        if (process.env.NODE_ENV === 'development') return

        let _this = this
        try {
          window.cookiePrivacy.onGrant('tracking', function() {
            if (_this.isDefined('fbq')) {
              const eventID = document.querySelector('meta[name="request_id"]').getAttribute('content')
              fbq('track', 'InitiateCheckout', {}, { eventID })
              initialize_facebook_advanced_matching()
              // console.log('fb track initiateCheckout')
            }

            if (_this.isDefined('twq')) {
              twq('event', 'tw-og6m8-og6oh', {});
            }
          })
        } catch (e) {
          Sentry.addBreadcrumb({
            message: '[CAUGHT] error tracking InitiateCheckout'
          });
          Sentry.captureException(e)
        }
      },
      isDefined(ref) {
        return typeof window[ref] !== 'undefined'
      },
      subscribe (email) {
        const body = {
          email: email,
          list_id: '3caf31968a1d7324efc349f0b45341a1',
          referrer: this.$cookie.get('referrer')
        }

        this.$http.post(`/subscribers`, body).then((response) => {
          console.log('posted', response)
        },
        response => {
          // something went wrong
        })
      },
      scroll_to_products() {
        this.$el.scrollIntoView({ behavior: 'smooth' })
      },
      reset_form () {
        this.submitting = false
        this.skip_address_validation = false
      },
      did_initiate_express_checkout() {
        this.express_checkout = true // needed for validations

        this.$v.$touch()

        // check that they've ordered something
        if (this.subtotal == 0) {
          const message = 'Please select a product to purchase.'
          this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
          this.reset_form()
          this.scroll_to_products()
          this.express_checkout = false
          return false
        }

        // check cable validations
        if (includes(this.order.products.arsenal.cables, '') || includes(this.order.products.arsenal_pro.cables, '')) {
          const message = 'Camera model is required.'
          this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
          this.express_checkout = false

          // do this in settimout so it doesn't conflict with something that
          // $toast is doing
          setTimeout(() => {
            const el = document.querySelectorAll('div.error')[0]
            if (el) {
              el.scrollIntoView({ block: 'center', behavior: 'smooth' })
            }
          }, 100)
          return false
        }

        // we're clear to checkout
        return true
      },
      did_cancel_express_checkout() {
        this.express_checkout = false
        this.reset_form()

        // clear any validations
        this.$v.$reset()

        // may need to clear taxes
        this.update_tax()
        // console.log("did_cancel_express_checkout")
      },
      did_complete_express_checkout(paymentResponse) {
        this.submitting = true

        if (this.isDefined('gtag')) {
          gtag('event', 'order submitted', { event_category: 'interactions' })
        }

        // save the payment token details
        this.stripe_source_id = paymentResponse.token.id
        this.card = paymentResponse.token.card
        this.payment_method = paymentResponse.methodName

        // copy over the contact information
        let contactInfo = {}
        contactInfo.email = paymentResponse.payerEmail
        contactInfo.phone_number = paymentResponse.payerPhone
        contactInfo.shipping_name = paymentResponse.shippingAddress.recipient
        contactInfo.shipping_address_1 = paymentResponse.shippingAddress.addressLine[0]
        contactInfo.shipping_address_2 = paymentResponse.shippingAddress.addressLine[1] || ''
        contactInfo.shipping_city = paymentResponse.shippingAddress.city
        contactInfo.shipping_country = country_name_from_alpha2(paymentResponse.shippingAddress.country) || paymentResponse.shippingAddress.country
        contactInfo.shipping_state = paymentResponse.shippingAddress.region
        contactInfo.shipping_zipcode = paymentResponse.shippingAddress.postalCode

        this.express_checkout_data = contactInfo

        // don't verify the address on ApplePay/GooglePay
        this.skip_address_validation = true

        // need to return the promise
        return this.submit_order(paymentResponse)
        // console.log("did_complete_express_checkout")
      },
      express_checkout_shipping_address_did_change(shippingAddress) {
        // console.log("express_checkout_shipping_address_did_change")
        this.$set(this.express_checkout_data, 'shipping_address_1', shippingAddress.addressLine[0])
        this.$set(this.express_checkout_data, 'shipping_address_2', shippingAddress.addressLine[1] || '')
        this.$set(this.express_checkout_data, 'shipping_city', shippingAddress.city)
        this.$set(this.express_checkout_data, 'shipping_country', country_name_from_alpha2(shippingAddress.country) || shippingAddress.country)
        this.$set(this.express_checkout_data, 'shipping_state', shippingAddress.region)
        this.$set(this.express_checkout_data, 'shipping_zipcode', shippingAddress.postalCode)

        return this.update_tax(true)
      },
      async save_cart() {
        const email = this.order.email
        if (email && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
          let product = 'arsenal_2'
          if (this.order.products.arsenal_pro.quantity > 0) {
            product = 'arsenal_2_pro'
          }

          try {
           await this.$http.post("/orders/cart", { email: email, product: product })
          } catch(e) {
            console.log(e)
          }
        }
      },
      numberWithCommas (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
    },
    components: { Products, OrderAddress, OrderAddressModal, ShippingMethod, StripePaymentRequestButton, StripeCard, StripePaymentElement, SpinnerButton, Totals }
  }
</script>
